import Axios from "axios"
import { v4 as uuid } from 'uuid'

import { config } from '../../config';
import {DONE_FETCH_HABITS, ERROR_FETCH_HABITS, START_FETCH_HABITS, START_SAVING_HABIT, ERROR_SAVING_HABIT, DONE_SAVING_HABIT, START_MARKING_COMPLETE, ERROR_MARKING_COMPLETE, DONE_MARKING_COMPLETE, START_FETCH_CHECKLISTS, ERROR_FETCH_CHECKLISTS, DONE_FETCH_CHECKLISTS, START_UNDO_COMPLETE, ERROR_UNDO_COMPLETE, DONE_UNDO_COMPLETE, START_DELETE_HABIT, ERROR_DELETE_HABIT, DONE_DELETE_HABIT} from "./constants";
import { addHabit, removeHabit } from "../Habit/actions";
import { markComplete, receivedChecklists, undoComplete } from '../Checklist/actions';

export function fetchHabits(){

  return async (dispatch) => {

    dispatch(startFetchHabits());

    try{
    
      let {data: {data: habits}} = await Axios.get(`${config.API_URL}/habits`);

      habits = habits.map(habit => ({...habit, created_at: new Date(habit.created_at), recurrence: JSON.parse(habit.recurrence)}))

      dispatch(doneFetchHabits(habits));

    } catch(e) {
      dispatch(errorFetchHabits());
    }

  }
}

export function startFetchHabits(){
   return {
      type: START_FETCH_HABITS,
   }
}

export function doneFetchHabits(habits){
  return {
    type: DONE_FETCH_HABITS,
    habits
  }
}

export function errorFetchHabits(){
  return {
     type: ERROR_FETCH_HABITS
  }
}



export function saveHabit(habit){
   return async (dispatch) => {
      habit = {...habit, uuid: uuid()}
      dispatch(addHabit(habit))
      dispatch(startSavingHabit(habit))

      try{
        let {data: savedHabit} = await Axios.post(`${config.API_URL}/habits`, habit)      

        setTimeout(() => {
          dispatch(doneSavingHabit({...habit, id: savedHabit.id}));
        }, 10000)

      } catch(e) {
        dispatch(errorSavingHabit(habit)) 
      }
   }
}


export function startSavingHabit(habit){
   return {
      type: START_SAVING_HABIT, 
      habit
   }
}


export function errorSavingHabit(habit){
   return {
     type: ERROR_SAVING_HABIT, 
     habit
   }
}

export function doneSavingHabit(habit){
   return {
     type: DONE_SAVING_HABIT, 
     habit
   }
}

export function requestDeleteHabit(habit){
  return async dispatch => {

    dispatch(removeHabit(habit.id));
    dispatch(startDeletingHabit(habit));

    try{
      await Axios.delete(`${config.API_URL}/habits/${habit.id}`);
      dispatch(doneDeletingHabit(habit));
    } catch(e) {
      dispatch(errorDeletingHabit(habit));
    }
  }
}

export function startDeletingHabit(habit){

  return {
    type: START_DELETE_HABIT, 
    habit
  }
}

export function errorDeletingHabit(habit){

  return {
    type: ERROR_DELETE_HABIT, 
    habit
  }
}

export function doneDeletingHabit(habit){

  return {
     type: DONE_DELETE_HABIT, 
     habit
  }
}


export function saveMarkComplete(habit, date){
  return async dispatch => {
    dispatch(markComplete(habit.id, date))

    dispatch(startMarkingComplete(habit, date))

    try{
      let _ = await Axios.put(`${config.API_URL}/checklists/${habit.id}/complete`, {date: date.setHours(0,0,0,0)});
      dispatch(doneMarkingComplete(habit, date));
    } catch(e) {
      dispatch(errorMarkingComplete(habit, date)) 
    }
  }
}


export function startMarkingComplete(habit, date){
  return {
    type: START_MARKING_COMPLETE, 
    habit, 
    date
  }
}

export function errorMarkingComplete(habit, date){
   return {
     type: ERROR_MARKING_COMPLETE, 
     habit, 
     date
   }
}

export function doneMarkingComplete(habit, date){

  return {
    type: DONE_MARKING_COMPLETE, 
    habit, 
    date
  }
}


export function saveUndoComplete(habit, date){
   return async dispatch => {
     dispatch(startUndoComplete(habit, date)); 
     dispatch(undoComplete(habit.id, date));
     try{
       await Axios.put(`${config.API_URL}/checklists/${habit.id}/undo-complete`, {date: date.setHours(0,0,0,0)});
       dispatch(doneUndoComplete(habit, date));
     } catch(e) {
       dispatch(errorUndoComplete(habit, date));
     }
   }
}

export function startUndoComplete(habit, date){
   return {
     type: START_UNDO_COMPLETE, 
     habit, 
     date
   }
}

export function errorUndoComplete(habit, date){
   return {
     type: ERROR_UNDO_COMPLETE, 
     habit, 
     date
   }
}

export function doneUndoComplete(habit, date){
   return {
     type: DONE_UNDO_COMPLETE, 
     habit, 
     date
   }
}

export function fetchChecklists(){

  return async dispatch => {
    dispatch(startFetchingChecklists());
    try{
      let { data: checklists } = await Axios.get(`${config.API_URL}/checklists`); 


      checklists = Object.entries(checklists).map( ([id, dates]) => {
        return [id, dates.map(date => new Date(parseInt(date)) ) ];
      }).reduce((acc, [id, dates]) => {
        return {...acc, [id]: dates}
      }, {});

      dispatch(doneFetchingChecklists());
      dispatch(receivedChecklists(checklists));

    } catch(e) {
      dispatch(errorFetchingChecklists()); 
    }
  }
}

export function startFetchingChecklists(){
   return {
     type: START_FETCH_CHECKLISTS
   }
}

export function errorFetchingChecklists(){
   return {
      type: ERROR_FETCH_CHECKLISTS
   }
}

export function doneFetchingChecklists(){
   return {
      type: DONE_FETCH_CHECKLISTS
   }
}
